export default "__VITE_ASSET__D_dd_ejj__"